import styles from '../styles';

export function getClickableStyle(props) {
  const { disabled, onClick, onMouseEnter } = props;
  return disabled || onClick || onMouseEnter
    ? styles.interactions.clickable
    : {};
}
